import { endpoints, poster, fetcherGET, fetcher, deleter, patcher, fetcherSwr } from '../utils/axios';
import { useMemo } from 'react';
import useSWR from 'swr';
// Device Reports
export function useGetDeviceReports(args = {}) {
  const URL = args ? [endpoints.report.getReports, { params: args }] : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      reports: data?.data || [],
      isLoading,
      tokenError: error,
      tokenValidating: isValidating,
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

//  All Reports
export function useGetAllReports(args = {}) {
  const URL = args ? [endpoints.reports.list, { params: args }] : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      reports: data?.data || [],
      isLoading,
      tokenError: error,
      tokenValidating: isValidating,
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

//  Update Report Status
export async function useUpdateReportStatus(args = {}) {
  try {
    const response = await poster(endpoints.interpretation.requestInterpretation, args);
    return response;
  } catch (error) {
    return { status: false, message: error?.response?.data?.message ?? error.message };
  }
}

//  Revoke Interpretation Request
export async function useRevokeInterpretationRequest(args = {}) {
  try {
    const response = await poster(endpoints.interpretation.revokeInterpretationRequest, args);
    return response;
  } catch (error) {
    return { status: false, message: error?.response?.data?.message ?? error.message };
  }
}

//  ECG Data
export function useGetEcgData(param, args = {}) {
  const URL = param ? [`${endpoints.interpretations.getEcgData}${param}`, { params: args }] : null;
  
  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      ecgData: data?.data || {},
      isLoading,
      tokenError: error,
      tokenValidating: isValidating,
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}



//  Save Data Interpretation
export async function useSetInterpretation(args = {}) {
  try {
    const response = await patcher(endpoints.interpretations.setInterpretation, args.bodyData);
    return response;
  } catch (error) {
    return { status: false, message: error?.response?.data?.message ?? error.message };
  }
}

export default {
  useGetAllReports,
  useGetDeviceReports,
  useGetEcgData,
  useSetInterpretation
};
